export const stringifyObjectArrays = (object: Record<string, any>) =>
  Object.fromEntries(
    Object.entries(object).map(([key, value]) => {
      return [key, Array.isArray(value) ? JSON.stringify(value) : value];
    }),
  );
